import MenuOpenIcon from '@mui/icons-material/MenuOpen';

import { IconButton } from '../../../components/icon-button';
import { Tooltip } from '../../../components/tooltip';
import { useFenrirTranslation } from '../../../locales/use-fenrir-translation';

export type CollapseButtonProps = {
  open?: boolean;
  onClick?: () => void;
};

/** @experimental In active development. Avoid using until further notice. */
export const CollapseButton = ({ open, onClick }: CollapseButtonProps) => {
  const { t } = useFenrirTranslation({ keyPrefix: 'dashboardLayout' });

  return (
    // tooltip title adds an aria-label on the children tag
    <Tooltip
      title={t(`navigation.${open ? 'collapse' : 'expand'}`)}
      placement="right"
    >
      <IconButton color="primary" onClick={onClick} size="small">
        <MenuOpenIcon
          sx={open ? { transform: 'scaleX(1)' } : { transform: 'scaleX(-1)' }}
        />
      </IconButton>
    </Tooltip>
  );
};
